import CardSplitContent from './CardSplitContent';

export * from './CardSplitContent';

export default CardSplitContent;
